module.exports = {"341504001":"史河街道","341504002":"平岗街道","341504102":"三元镇","341504103":"洪集镇","341504104":"姚李镇","341504200":"孙岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341504.json
// module id = 1139
// module chunks = 0